// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-compliance-world-map {
    display: block;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.audit-compliance-world-map__ocean {
    fill: #121a22;
}

.audit-compliance-world-map__fw-label {
    paint-order: stroke fill;
    stroke: rgba(6, 10, 14, 0.92);
    stroke-width: 3px;
    stroke-linejoin: round;
}

.audit-compliance-world-map__fw-label--clickable:hover {
    filter: brightness(1.12);
}

.audit-compliance-world-map__country--clickable {
    cursor: pointer;
}

.audit-compliance-world-map__country--clickable:hover {
    filter: brightness(1.08);
}

.audit-compliance-world-map__country--selected {
    filter: drop-shadow(0 0 4px rgba(192, 159, 83, 0.55));
}

/* CCPA / CPRA: state overlay on top of country-level US polygon */
.audit-compliance-world-map__ccpa-california {
    paint-order: stroke fill;
    pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AuditSnapshotCard/AuditComplianceWorldMap.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qDAAqD;AACzD;;AAEA,kEAAkE;AAClE;IACI,wBAAwB;IACxB,oBAAoB;AACxB","sourcesContent":[".audit-compliance-world-map {\n    display: block;\n    width: 100%;\n    height: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 8px;\n    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);\n}\n\n.audit-compliance-world-map__ocean {\n    fill: #121a22;\n}\n\n.audit-compliance-world-map__fw-label {\n    paint-order: stroke fill;\n    stroke: rgba(6, 10, 14, 0.92);\n    stroke-width: 3px;\n    stroke-linejoin: round;\n}\n\n.audit-compliance-world-map__fw-label--clickable:hover {\n    filter: brightness(1.12);\n}\n\n.audit-compliance-world-map__country--clickable {\n    cursor: pointer;\n}\n\n.audit-compliance-world-map__country--clickable:hover {\n    filter: brightness(1.08);\n}\n\n.audit-compliance-world-map__country--selected {\n    filter: drop-shadow(0 0 4px rgba(192, 159, 83, 0.55));\n}\n\n/* CCPA / CPRA: state overlay on top of country-level US polygon */\n.audit-compliance-world-map__ccpa-california {\n    paint-order: stroke fill;\n    pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
